/** @format */

import { FunctionComponent as FC, useMemo } from 'react';
import styled from 'styled-components';
import { breakpointUpTo } from '../../theme/mixins';
import { ProductCardEntry } from '../../types/shared';
import { ProductCard } from '../ProductCard';
import { ContainerRightSide } from '../ui/Layout';
import { SliderClassic } from './SliderClassic';

export const AllSliders: FC<Props> = ({ products }) => {
  const slides = useMemo(
    () =>
      products.map(prod => {
        return {
          el: <ProductCard card={prod.fields} />,
          key: prod.sys.id,
        };
      }),
    [products],
  );

  return (
    <StyledContainer as="section">
      <SliderWrapper>
        <SliderClassic slides={slides} withCounter />
      </SliderWrapper>
    </StyledContainer>
  );
};
type Props = {
  products: ProductCardEntry[];
};

const StyledContainer = styled(ContainerRightSide)`
  margin-inline: auto;
  padding-inline: 3rem !important;
  width: 1440px;
  row-gap: 2rem;
  column-gap: 4.75rem;
  padding-block: 3.75rem 0;
  ${breakpointUpTo.xxl`
   width: 100%;
   margin-inline: auto;
   padding-inline: 3rem !important;
  `};
  ${breakpointUpTo.sm`
   padding-inline: 0.5rem !important;
  `};
`;

const SliderWrapper = styled.div`
  position: relative;
`;
